exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".LoginButton-button {\n  color: #f75c03;\n  font-weight: bold;\n}\n", ""]);

